module.exports = __webpack_public_path__ + "media/images/lb/514-2284433bfc459e2904acf1e30c69935b.svg";